import { useCallback, useEffect } from 'react';

import { usePintoWriterCampaignsLazyQuery } from '../core/graphql/operation-hooks';
import { PintoProductCampaignsFilter } from '../core/graphql/types';

const INITIAL_LIMIT = 10;

const useQueryPintoWriterCampaigns = () => {
  const [queryPintoWriterCampaigns, { data, loading }] = usePintoWriterCampaignsLazyQuery({ fetchPolicy: 'network-only' });

  const fetchPintoWriterCampaigns = useCallback(
    (filter?: PintoProductCampaignsFilter) => {
      queryPintoWriterCampaigns({
        variables: {
          filter: {
            ...filter,
            limit: filter?.limit || INITIAL_LIMIT,
          },
        },
      });
    },
    [queryPintoWriterCampaigns],
  );

  useEffect(() => fetchPintoWriterCampaigns(), [fetchPintoWriterCampaigns]);

  return {
    fetchPintoWriterCampaigns,
    pintoWriterCampaigns: data?.pintoWriterCampaigns,
    isLoadingPintoWriterCampaigns: loading,
  };
};

export default useQueryPintoWriterCampaigns;
